// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { KyberNetwork, Messages2, Calendar1, Kanban, Profile2User, Bill, UserSquare, ShoppingBag,Ticket,Ticket2, Image,Home2 } from 'iconsax-react';

// icons
const icons = {
  applications: KyberNetwork,
  chat: Messages2,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag,
  ticket:Ticket,
  ticket2:Ticket2,
  home:Home2,
  img_banner:Image,
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const applications = {
  id: 'group-applications',
  title: <FormattedMessage id="applications" />,
  icon: icons.applications,
  type: 'group',
  children: [
    // {
    //   id: 'chat',
    //   title: <FormattedMessage id="chat" />,
    //   type: 'item',
    //   url: '/apps/chat',
    //   icon: icons.chat,
    //   breadcrumbs: false
    // },
    // {
    //   id: 'calendar',
    //   title: <FormattedMessage id="calendar" />,
    //   type: 'item',
    //   url: '/apps/calendar',
    //   icon: icons.calendar
    // },
    // {
    //   id: 'kanban',
    //   title: <FormattedMessage id="kanban" />,
    //   type: 'item',
    //   icon: icons.kanban,
    //   url: '/apps/kanban/board'
    // },
    {
      id: 'Home',
      title: <FormattedMessage id="Home" />,
      type: 'item',
      url: '/',
      icon: icons.home,
    },
    // {
    //         id: 'Add New Account',
    //         title: <FormattedMessage id="Add New Account" />,
    //         type: 'item',
    //         url: '/apps/profiles/user/personal',
    //         icon: icons.profile,
    //       },
    {
      id: 'Seeker',
      title: <FormattedMessage id="Seeker" />,
      type: 'item',
      icon: icons.customer,
      url: '/apps/customer/seeker-list'
      // children: [
      //   {
      //     id: 'customer-list',
      //     title: <FormattedMessage id="list" />,
      //     type: 'item',
      //     url: '/apps/customer/customer-list'
      //   },
      //   {
      //     id: 'customer-card',
      //     title: <FormattedMessage id="cards" />,
      //     type: 'item',
      //     url: '/apps/customer/customer-card'
      //   }
      // ]
    },
    {
      id: 'Provider',
      title: <FormattedMessage id="Provider" />,
      type: 'item',
      icon: icons.customer,
      url: '/apps/customer/provider-list'
      
    },
    {
      id: 'Support Tickets',
      title: <FormattedMessage id="Support Tickets" />,
      type: 'item',
      icon: icons.ticket,
      url: '/apps/customer/support-tickets-list'
      
    },
    {
            id: 'Application Banner',
            title: <FormattedMessage id="Application Banner" />,
            type: 'item',
            // url: '/apps/e-commerce/product-list',
            url: '/apps/customer/application_banners',
            icon: icons.img_banner,
      },
     
  {
    id: 'referral-management',
    title: <FormattedMessage id="Referrals Management" />,
    type: 'collapse',
    icon: icons.profile,
    children: [
      {
        id: 'Collaborators',
        title: <FormattedMessage id="Collaborators" />,
        type: 'item',
        url: '/apps/referral/collaborators',
        breadcrumbs: false
      },
      {
        id: 'view-commission',
        title: <FormattedMessage id="View Commission" />,
        type: 'item',
        url: '/apps/referral/commission'
      },
      
    ]
  },
    //  {
    //    id: 'invoice',
    //    title: <FormattedMessage id="invoice" />,
    //    url: '/apps/invoice/dashboard',
    //    type: 'collapse',
    //    icon: icons.invoice,
    //    breadcrumbs: true,
    //    children: [
    //      {
    //        id: 'create',
    //        title: <FormattedMessage id="create" />,
    //        type: 'item',
    //        url: '/apps/invoice/create'
    //      },
    //      {
    //        id: 'details',
    //        title: <FormattedMessage id="details" />,
    //        type: 'item',
    //        url: '/apps/invoice/details/1'
    //      },
    //      {
    //        id: 'list',
    //        title: <FormattedMessage id="list" />,
    //        type: 'item',
    //        url: '/apps/invoice/list'
    //      },
    //      {
    //        id: 'edit',
    //        title: <FormattedMessage id="edit" />,
    //        type: 'item',
    //        url: '/apps/invoice/edit/1'
    //      }
    //    ]
    //  },
     {
       id: 'gig-management',
       title: <FormattedMessage id="Gig Management" />,
       type: 'collapse',
       icon: icons.profile,
       children: [
         {
           id: 'Pending',
           title: <FormattedMessage id="Pending" />,
           type: 'item',
           url: '/apps/gigs/pending_gigs',
           breadcrumbs: false
         },
         {
           id: 'Approved',
           title: <FormattedMessage id="Approved" />,
           type: 'item',
           url: '/apps/gigs/approved_gigs'
         },
         {
          id: 'Rejected',
          title: <FormattedMessage id="Rejected" />,
          type: 'item',
          url: '/apps/gigs/rejected_gigs'
        },
        {
          id: 'Paused',
          title: <FormattedMessage id="Paused" />,
          type: 'item',
          url: '/apps/gigs/paused_gigs'
        }
       ]
     },

    // {
    //   id: 'e-commerce',
    //   title: <FormattedMessage id="e-commerce" />,
    //   type: 'collapse',
    //   icon: icons.ecommerce,
    //   children: [
    //     {
    //       id: 'products',
    //       title: <FormattedMessage id="products" />,
    //       type: 'item',
    //       url: '/apps/e-commerce/products'
    //     },
    //     {
    //       id: 'product-details',
    //       title: <FormattedMessage id="product-details" />,
    //       type: 'item',
    //       url: '/apps/e-commerce/product-details/1',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'product-list',
    //       title: <FormattedMessage id="product-list" />,
    //       type: 'item',
    //       url: '/apps/e-commerce/product-list',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'add-new-product',
    //       title: <FormattedMessage id="add-new-product" />,
    //       type: 'item',
    //       url: '/apps/e-commerce/add-new-product'
    //     },
    //     {
    //       id: 'checkout',
    //       title: <FormattedMessage id="checkout" />,
    //       type: 'item',
    //       url: '/apps/e-commerce/checkout'
    //     }
    //   ]
    // }
  ]
};

export default applications;
